import type { Clock, Timestamp } from '@anytracker/core'

/**
 * The web implementation of core's `Clock` port (ADR-0002).
 *
 * Core never reads the system clock itself, so this is where `Date.now()` is
 * allowed to appear. The mobile app will supply its own equivalent and core will
 * not know the difference.
 */
export class SystemClock implements Clock {
  now(): Timestamp {
    return { epochMs: Date.now(), timeZone: this.timeZone() }
  }

  timeZone(): string {
    // `resolvedOptions().timeZone` is the device's IANA zone. Every browser this
    // app targets returns a real identifier here rather than a fixed offset.
    return Intl.DateTimeFormat().resolvedOptions().timeZone
  }
}
